import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {Card, Loader, Dimmer, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {getUrlParameters} from '../../../common/util/urlParameters';
import {yearFormat} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {downloadFile} from '../../../common/util/file';
import {Actions} from '../../../common/actions';
import SearchForm from './SearchForm';
import './styles.scss';

const INITIAL_STATE = {
  'dealer': '',
  'typeTwc': 'TODOS',
  'year': null,
  'generating': false,
};

class WarrantyErrorRate extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.WarrantyErrorRate,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchDealers('importers');
  }

  componentDidUpdate() {
    const {fileURL} = this.props;

    if (fileURL) {
      downloadFile(fileURL);
      this.props.clearWarrantyReportURLFile();
    }
  }

  handleChange = (e, {name, value}) => {
    this.setState({[name]: value});
  };

  handleChangeDate = (field, date) => {
    const dateValue = date ? moment(date).toDate() : null;
    this.setState({[field]: dateValue});
  };

  handleClear = () => {
    this.setState(INITIAL_STATE);
  };

  generateFile = async() => {
    const {dealer, typeTwc, year} = this.state;
    const params = {dealer, typeTwc, 'year': moment(year).format(yearFormat)};
    const baseUrl = process.env.REP_API_URL;
    const fileUrl = `${baseUrl}/warranties/error-rate/report${getUrlParameters(
      params
    )}`;
    // downloadFile envía el token (Authorization Bearer) y descarga el blob.
    // Se usa en lugar de window.open, que abre una pestaña sin token y provoca 401.
    this.setState({'generating': true});
    await downloadFile(fileUrl);
    this.setState({'generating': false});
  };

  render() {
    const {year, dealer, generating} = this.state;
    const {dealers, loading} = this.props;
    const isLoading = loading || generating;
    const validateForm = !year || !dealer;

    return (
      <div className="warranty-report-container">
        {isLoading && (
          <Dimmer active inverted>
            <Loader inverted content="Generando Archivo..." />
          </Dimmer>
        )}
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Reporte Tasa de Error Garantías</h2>
              <div className="title-bar-actions">
                <Button secondary disabled={isLoading} onClick={this.handleClear}>
                    LIMPIAR
                </Button>
                <Button
                  primary
                  disabled={validateForm || isLoading}
                  onClick={this.generateFile}
                >
                    GENERAR ARCHIVO
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <div className="warranty-error-rate-form">
            <SearchForm
              {...this.state}
              validateForm={validateForm}
              dealersOptions={dealers}
              handleClear={this.handleClear}
              handleChange={this.handleChange}
              handleChangeDate={this.handleChangeDate}
            />
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'dealers': state.dealer.list,
    'warrantyStatus': state.processedWarranty.warrantyStatus,
    'loading': state.warrantyErrorRate.loading,
  };
};

const {
  navigateTo,
  withRouter,
  fetchDealers,
  fetchWarrantyStatus,
  fetchWarrantyReportList,
  clearWarrantyReportList,
  clearSearchPartWarranty,
  clearWarrantyReportURLFile,
  generateWarrantyErrorRateReport,
  clearReplacementSectionPartQuotes,
} = Actions;

const mapDispatchToProps = {
  navigateTo,
  fetchDealers,
  fetchWarrantyStatus,
  fetchWarrantyReportList,
  clearWarrantyReportList,
  clearSearchPartWarranty,
  clearWarrantyReportURLFile,
  generateWarrantyErrorRateReport,
  clearReplacementSectionPartQuotes,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WarrantyErrorRate)
);
